import { Component, OnInit } from '@angular/core';
import { UserManagementService } from '../user-management/user-management.service';

@Component({
    selector: 'app-operator-nav',
    templateUrl: './operator-nav.component.html',
    styleUrls: ['./operator-nav.component.css'],
    standalone: false
})
export class OperatorNavComponent implements OnInit {
  public isCollapsed = false;
  public isMenuCollapsed = true;
  public user: any;
  public siteinfo:any;
  sitename:any;
  constructor(private userService: UserManagementService) { }

  ngOnInit(): void {
    this.user = this.userService.getUserDetail();
    this.siteinfo=this.userService.getSiteDetail();
    this.sitename =this.siteinfo[0].site_name;
  }

  logout() {
    this.userService.logout();
    sessionStorage.removeItem('visitedUserManagementSites');
    sessionStorage.removeItem('admin_id');
  }

}
